// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { agentChallengePurposeGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    purpose: agentChallengePurposeGuard,
    nonceHash: z.string().min(1).max(64),
    expiresAt: z.number(),
    consumedAt: z.number().nullable().optional(),
    attemptCount: z.number().optional(),
    clientIp: z.string().max(64).nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    purpose: agentChallengePurposeGuard,
    nonceHash: z.string().min(1).max(64),
    expiresAt: z.number(),
    consumedAt: z.number().nullable(),
    attemptCount: z.number(),
    clientIp: z.string().max(64).nullable(),
    createdAt: z.number(),
});
export const AgentKeyChallenges = Object.freeze({
    table: 'agent_key_challenges',
    tableSingular: 'agent_key_challenge',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        keyId: 'key_id',
        purpose: 'purpose',
        nonceHash: 'nonce_hash',
        expiresAt: 'expires_at',
        consumedAt: 'consumed_at',
        attemptCount: 'attempt_count',
        clientIp: 'client_ip',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'keyId',
        'purpose',
        'nonceHash',
        'expiresAt',
        'consumedAt',
        'attemptCount',
        'clientIp',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
